import { InternalUserRoles } from "../../constants/roles";
import { ReactComponent as TestsIcon } from "../../assets/chemistry.svg";
import Tests from "../../pages/Tests";
import NewTest from "../../pages/Tests/NewTests";
import { ModuleRouteConfig, RouteConfig } from "../types";

export const BASE_PATH = "/tests";

export const baseRoute: ModuleRouteConfig = {
  path: BASE_PATH,
  component: Tests,
  allowedRoles: InternalUserRoles,
  label: "Tests",
  icon: () => <TestsIcon />,
  isCustomIcon: true,
  hasDivider: false,
};

export const testsRoutes: { [key: string]: RouteConfig } = {
  tests: baseRoute,
  newTests: {
    path: `/newTest`,
    component: NewTest,
    allowedRoles: InternalUserRoles,
  },
};
